import { cn } from '@/utils/commons';
import * as React from 'react';
import { Status, StatusLabel } from './statusLabel';
import { Label } from './label';

// SVG icons for status
const SuccessIcon: React.FC = () => (
  <svg className="w-5 h-5 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
  </svg>
);
const ErrorIcon: React.FC = () => (
  <svg className="w-5 h-5 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
  </svg>
);

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  autocomplete?: string;
  error?: string;
  autoFocus?: boolean;
  variant?: 'default' | 'checkbox';
  status?: 'success' | 'error';
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    { id, value, autoFocus, autocomplete, placeholder, error, className, variant = 'default', status, ...props },
    ref
  ) => {
    return (
      <Label htmlFor={id} className="relative">
        <input
          className={cn(
            'flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent font-normal file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
            'pl-3 py-2 bg-background rounded-md border justify-start items-center inline-flex focus-visible:ring-offset-0', // increased pr-10 for icon
            variant === 'checkbox' && 'h-8 p-2 text-sm',
            // status ? 'pr-10' : 'pr-3',
            className
          )}
          id={id}
          value={value}
          autoComplete={autocomplete}
          placeholder={placeholder}
          ref={ref}
          autoFocus={autoFocus}
          {...props}
        />
        {/* Status icon */}
        {status === 'success' && (
          <span className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">
            <SuccessIcon />
          </span>
        )}
        {status === 'error' && (
          <span className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">
            <ErrorIcon />
          </span>
        )}
        {/* Error message below input */}
        {error && <StatusLabel status={Status.error} message={error} />}
      </Label>
    );
  }
);
Input.displayName = 'Input';

export { Input };
